import React, { useState, useRef } from "react"; // Add React import if missing

import { useNavigate } from "react-router-dom";
import "./MegaMenu.css";
import { useTranslation } from "react-i18next";

const MegaMenu = ({categories}) => {
  const params = new URLSearchParams();
  const navigate = useNavigate();
  const timerRef = useRef(null);
  const { t } = useTranslation();
  const [openMenu, setOpenMenu] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);

  const handleCategoryClick = (categoryId, subcategoryId = "") => {
    params.set("category_id", categoryId);
    subcategoryId && params.set("subcategory_id", subcategoryId);
    navigate(`/products?${params.toString()}`, { replace: true });
    setOpenMenu(false);
  };

  const handleMouseEnter = () => {
    clearTimeout(timerRef.current);
    setOpenMenu(true);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setOpenMenu(false);
    }, 300);
  };

  return (
    <li
      className="menu-item"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <a href="#" className="menu-link">
        {t("Products")}
      </a>
      <div className={`mega-menu ${openMenu ? "show" : ""}`}>
        <div className="mega-menu-content">
          <div className="categories-column">
            {categories?.data?.map((cat) => (
              <div
                key={cat._id}
                className="category-item"
                onMouseEnter={() => setHoveredCategory(cat)}
                onClick={() => handleCategoryClick(cat._id)}
              >
                {/* Render the icon as an image if iconName is an SVG file */}
                {cat.iconName ? (
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${cat.iconName}`}
                    alt={`${cat.name} icon`}
                    className="category-icon-nav"
                  />
                ) : (
                  <span
                    className="default-icon"
                    style={{
                      marginRight: "15px",
                      height: "50px",
                      width: "50px",
                    }}
                  >
                    🔍
                  </span> // Default icon if not found
                )}
                {cat.name}
              </div>
            ))}
          </div>

          <div className="subcategories-column">
            {hoveredCategory ? (
              hoveredCategory.subcategories?.map((sub) => (
                <div key={sub._id} className="subcategory-item">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleCategoryClick(hoveredCategory._id, sub._id);
                    }}
                  >
                    {sub.name}
                  </a>
                </div>
              ))
            ) : (
              <p className="subcategory-placeholder">
                Håll muspekaren över en kategori
              </p>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

export default MegaMenu;
